    <!--Header-->
    <div class="pedLef">
        <div class="col-md-12 col-sm-12 col-12">
        <div class="row">
            <div class="col-md-9 col-sm-10 col-10" style="padding-left: 0px;">
                <h4 class="modal-title"><span id="ApntmntHdr" class="font18">Select {{ isShowCS ? 'Customer / Supplier' : (isCust ? 'Customer' : 'Supplier')}}</span></h4>
            </div>
            <div class="col-md-3 col-sm-2 col-2" style="padding: 0px;">
            <i class="closeMdl zmdi zmdi-close brdrRadius3" style="float: right;" (click)="passBack()"></i>
            </div>
            <div class="wdth">
                <span class="input-icons msearch">
                    <span class="fa fa-search"></span>
                    <input class="form-control formCtlFltr brdrRadius3" [(ngModel)]="search" placeholder="Search" type="text">
                </span>
            </div>
        </div>
    </div>
   
    <div *ngIf="!isShowCS">
        <div *ngIf="customers.length > 0 && isCust">
            <div class="col-md-12 col-sm-12 col-xs-12 maxHeightForCmp" style="text-align: center; padding: 0px; margin-bottom:3%; overflow: auto; border-radius: 3px;"
            *ngIf="(customers | filter : 'Cmp,Name').length > 0">
                <div class="col-md-12 col-sm-12 col-xs-12 {{(customers | filter:'Cmp,Name':search).length > 0 ? 'brdr': ''}}">
                    <div *ngFor="let c of customers | filter:'Cmp,Name':search | sort: 'Cmp' : search : 0" class="col-md-12 col-sm-12 col-xs-12"
                            style="padding: 5px 7px; cursor: pointer; border-bottom: 1px solid #ddd;" (click)="selectCust(c);">
                        <div class="col-md-11 col-sm-3 col-xs-3 mrgnTp8" style="padding: 0px; margin-bottom: 2px; font-weight: 500;">
                            <div class="" style="padding: 0px; margin-bottom: 2px; font-size: 12px; font-weight: bold;">{{c.Cmp}}</div>
                            <div style="font-size: 12px; color: #777;">{{c.Name}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="suppliers.length > 0 && !isCust">
            <div class="col-md-12 col-sm-12 col-xs-12 maxHeightForCmp" style="text-align: center; padding: 0px; margin-bottom:3%; overflow: auto; border-radius: 3px;"
            *ngIf="(suppliers | filter : 'Cmp,Name').length > 0">
                <div class="col-md-12 col-sm-12 col-xs-12 {{(suppliers | filter:'Cmp,Name':search).length > 0 ? 'brdr': ''}}">
                    <div *ngFor="let s of suppliers | filter:'Cmp,Name':search | sort: 'Cmp' : search : 0" class="col-md-12 col-sm-12 col-xs-12"
                            style="padding: 5px 7px; cursor: pointer; border-bottom: 1px solid #ddd;" (click)="selectCust(s);">
                        <div class="col-md-11 col-sm-3 col-xs-3 mrgnTp8" style="padding: 0px; margin-bottom: 2px; font-weight: 500;">
                            <div class="" style="padding: 0px; margin-bottom: 2px; font-size: 12px; font-weight: bold;">{{s.Cmp}}</div>
                            <div style="font-size: 12px; color: #777;">{{s.Name}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="isShowCS">
        <div *ngIf="companyList.length > 0" class="col-md-12 col-sm-12 col-xs-12 maxHeightForCmp" style="text-align: center; padding: 0px; margin-bottom:3%; overflow: auto; border-radius: 3px;">
            <div class="col-md-12 col-sm-12 col-xs-12 {{(companyList | filter :'Cmp,Name':search).length > 0 ? 'brdr': ''}}">
                <div *ngFor="let c of companyList | filter:'Cmp,Name':search | sort: 'Cmp' : search : 0" class="col-md-12 col-sm-12 col-xs-12"
                        style="padding: 5px 7px; cursor: pointer; border-bottom: 1px solid #ddd;" (click)="selectCust(c);">
                    <div class="col-md-11 col-sm-3 col-xs-3 mrgnTp8" style="padding: 0px; margin-bottom: 2px; font-weight: 500;">
                        <div style="padding: 0px; margin-bottom: 2px; font-size: 12px; font-weight: bold;">{{c.Cmp}}</div>
                        <div style="font-size: 12px; color: #777;">{{c.Name}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="col-md-12 col-sm-12 col-xs-12 margBtm10"
         style="cursor: pointer; padding: 0px;" *ngIf="(companyList | filter:'Cmp,Name':search).length == 0">
        <div class="nrf brdrRadius3"> No record found.</div>
    </div>
</div>